const MasterScreenReducer = (state = {}, action) => {
  switch (action.type) {
    case "getExceptionListSuccess": {
      return Object.assign({}, state, {
        ExceptionList: action.data,
      });
      break;
    }
    case "GetCalibrationShipCountSuccess": {
      return Object.assign({}, state, {
        CalibrationShipCount: action.data,
      });
      break;
    }
    case "GetCalibrationSearchSuccess": {
      return Object.assign({}, state, {
        CalibrationSearchList: action.data,
      });
      break;
    }

    case "GetClientShipDetailsSuccess": {
      return Object.assign({}, state, {
        ClientShipDetailsList: action.data,
      });
      break;
    }
    case "ExceptionDetail": {
      return Object.assign({}, state, {
        ExceptionDetail: action.data,
      });
      break;
    }
    case "getKeywordListSuccess": {
      return Object.assign({}, state, {
        KeywordList: action.data,
      });
      break;
    }
    case "KeywordDetail": {
      return Object.assign({}, state, {
        KeywordDetail: action.data,
      });
      break;
    }
    case "getStaffInfoListSuccess": {
      return Object.assign({}, state, {
        StaffInfoList: action.data,
      });
      break;
    }
    case "StaffDetails": {
      return Object.assign({}, state, {
        StaffDetails: action.data,
      });
      break;
    }
    case "getClientListSuccess": {
      return Object.assign({}, state, {
        ClientList: action.data,
      });
      break;
    }
    case "ClientDetails": {
      return Object.assign({}, state, {
        ClientDetails: action.data,
      });
      break;
    }
    // case "putClientDetailsSuccess": {
    //     return Object.assign({}, state, {
    //         ClientUserDetails: action.data,
    //     });
    //     break;
    // }
    // case "postClientDetailsSuccess": {
    //     return Object.assign({}, state, {
    //         ClientDetails: action.data,
    //     });
    //     break;
    // }
    // case "getClientUsersListSuccess": {
    //     return Object.assign({}, state, {
    //         clientUserList: action.data,
    //     });
    //     break;
    // }
    case "ClientUserDetails": {
      return Object.assign({}, state, {
        ClientUserDetails: action.data,
      });
      break;
    }
    case "getClientDetailsSuccess":
      return Object.assign({}, state, {
        ClientDetails: action.data,
        ClientManagementDetails: action.data,
      });
      break;
    case "getClientUsersListSuccess":
      return Object.assign({}, state, {
        clientUserList: action.data,
      });
      break;
    case "getShipManagementListSuccess": {
      return Object.assign({}, state, {
        ShipList: action.data,
      });
      break;
    }
    case "getShipManagementDetailSuccess": {
      return Object.assign({}, state, {
        ShipDetails: action.data,
      });
      break;
    }
    case "AttachmentUploadHKCSuccess": {
      return Object.assign({}, state, {
        HKCAttachment: action.data,
      });
      break;
    }
    case "AttachmentUploadEUSSRSuccess": {
      return Object.assign({}, state, {
        EUSSRAttachment: action.data,
      });
      break;
    }
    case "AttachmentUploadFullManualSuccess": {
      return Object.assign({}, state, {
        FullManualAttachment: action.data,
      });
      break;
    }
    case "GetPaintCoatingList": {
      return Object.assign({}, state, {
        PaintCoatingList: action.data,
      });
      break;
    }
    case "GetEquipmentMachineryList": {
      return Object.assign({}, state, {
        EquipmentMachineryList: action.data,
      });
      break;
    }
    case "GetStructureHullList": {
      return Object.assign({}, state, {
        StructureHullList: action.data,
      });
      break;
    }
    case "GetStoreList": {
      return Object.assign({}, state, {
        StoreList: action.data,
      });
      break;
    }
    case "EditMaterial": {
      return Object.assign({}, state, {
        EditMaterial: action.data,
      });
      break;
    }
    case "GetPaintCoatingDetails": {
      return Object.assign({}, state, {
        PaintCoatingDetails: action.data,
      });
      break;
    }
    case "GetEquipmentMachineryDetails": {
      return Object.assign({}, state, {
        EquipmentMachineryDetails: action.data,
      });
      break;
    }
    case "GetStructureHullDetails": {
      return Object.assign({}, state, {
        StructureHullDetails: action.data,
      });
      break;
    }
    case "GetStoreDetails": {
      return Object.assign({}, state, {
        StoreDetails: action.data,
      });
      break;
    }
    case "EditUser": {
      return Object.assign({}, state, {
        EditUser: action.data,
      });
      break;
    }
    case "GetFleetManagerDetails": {
      return Object.assign({}, state, {
        fleetManagerDetail: action.data,
      });
      break;
    }
    case "GetTechSuperintendentDetails": {
      return Object.assign({}, state, {
        TechSuperintendentDetail: action.data,
      });
      break;
    }
    case "GetTechExecutiveDetails": {
      return Object.assign({}, state, {
        TechExecutiveDetail: action.data,
      });
      break;
    }
    case "GetFleetManagerlist": {
      return Object.assign({}, state, {
        fleetManagerlist: action.data,
      });
      break;
    }
    case "GetTechSuperintendentlist": {
      return Object.assign({}, state, {
        TechSuperintendentlist: action.data,
      });
      break;
    }
    case "GetTechExecutivelist": {
      return Object.assign({}, state, {
        TechExecutivelist: action.data,
      });
      break;
    }
    // case "fleetManagerDetail":
    //     return Object.assign({}, state, {
    //         fleetManagerDetail: action.data,
    //     });
    //     break;
    // case "techSuperintendentDetail":
    //     return Object.assign({}, state, {
    //         techSuperintendentDetail: action.data,
    //     });
    //     break;
    // case "techExecutiveDetail":
    //     return Object.assign({}, state, {
    //         techExecutiveDetail: action.data,
    //     });
    //     break;
    // case "getCompanyListSuccess": {
    //     return Object.assign({}, state, {
    //         CompanyNames: action.data.companyName,
    //     });
    //     break;
    // }
    case "getCompanyUsersListSuccess": {
      return Object.assign({}, state, {
        CompanyUsers: action.data,
      });
      break;
    }
    case "fleetManagerListSuccess":
      return Object.assign({}, state, {
        fleetManagerList: action.data,
      });
      break;
    case "techSuperintendentListSuccess":
      return Object.assign({}, state, {
        techSuperintendentList: action.data,
      });
      break;
    case "techExecutiveListSuccess":
      return Object.assign({}, state, {
        techExecutiveList: action.data,
      });
      break;
    case "companyName": {
      return Object.assign({}, state, {
        companyName: action.data,
      });
      break;
    }
    case "pagenumber": {
      return Object.assign({}, state, {
        pagesearch: action.data,
      });
      break;
    }
    case "getClientUserListSuccess":
      return Object.assign({}, state, {
        ClientUsersList: action.data,
      });
      break;
     
      //Report reducer
      case "getReportListSuccess":
        return Object.assign({}, state, {
          ReportSearchDetails: action.data,
        });
        break;
       
        case "getClientNameListSuccess":
      return Object.assign({}, state, {
        ClientNameList: action.data,
      });
    case "getMailAlertSuccess": {
      return Object.assign({}, state, {
        MailAlert: action.data,
      });
      break;
    }
      break;
    default: {
      return state;
    }
  }
};
export default MasterScreenReducer;
